import { useQuery } from '@apollo/client';
import type { UseProvidersListFetch } from '@openx/components-provider/lib/utils/context/ProviderHookTypes.ts';
import { GetProvidersListDocument } from '../../../graphql/query/providers/GetProvidersList.generated.tsx';

export const useProvidersListFetch: UseProvidersListFetch = ({ onCompleted, variables }) => {
  const {
    data: { provider: providers } = {},
    error,
    loading,
  } = useQuery(GetProvidersListDocument, {
    onCompleted: ({ provider_aggregate }) => onCompleted?.(provider_aggregate.aggregate?.count),
    variables,
  });

  return {
    error,
    loading,
    providers: providers ?? [],
  };
};
